var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProwordCount = function SvgProwordCount(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.59,
    height: 89,
    viewBox: "0 0 114.59 89",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9bc83a;\n      }\n\n      .cls-2 {\n        stroke: #40535e;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #c5c5c5;\n      }\n\n      .cls-5 {\n        fill: #3b9c7c;\n      }\n\n      .cls-6 {\n        fill: #f7981d;\n      }\n\n      .cls-7 {\n        fill: #f59ebb;\n      }\n\n      .cls-8 {\n        fill: #e70d55;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 59.59,
    width: 55,
    height: 55,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 26.21,
    width: 55,
    height: 55,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.59,
    y: 9.5,
    width: 97,
    height: 62,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 94.66,
    cy: 69.07,
    r: 19.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.59,75.85c-1.77-.02-3.44-.8-4.59-2.15-1-1.24-1.84-2.61-2.49-4.06-.56-1.25-1.27-2.43-2.12-3.52-.63-.84-1.63-1.32-2.67-1.29-2.34,0-4.24,1.9-4.24,4.24s1.9,4.24,4.24,4.24c1.55,0,2.54-.9,3.51-2.45,.42,.85,.88,1.67,1.39,2.47-1.13,1.59-2.95,2.53-4.9,2.52-3.75,0-6.78-3.04-6.78-6.78s3.04-6.78,6.78-6.78c1.77,.02,3.44,.8,4.58,2.15,1,1.24,1.83,2.61,2.48,4.06,.56,1.25,1.27,2.43,2.12,3.51,.63,.84,1.63,1.32,2.69,1.3,2.34,0,4.24-1.9,4.24-4.24s-1.9-4.24-4.24-4.24c-1.55,0-2.54,.91-3.51,2.47-.42-.85-.88-1.68-1.39-2.48,1.12-1.6,2.95-2.54,4.9-2.53,3.75,0,6.78,3.03,6.78,6.78,0,3.75-3.03,6.78-6.78,6.78Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 21.46,
    y: 21.1,
    width: 38.03,
    height: 2.5,
    rx: 1.25,
    ry: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 21.46,
    y: 57.41,
    width: 47.93,
    height: 5,
    rx: 2.5,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 21.46,
    y: 34.9,
    width: 70.69,
    height: 2.5,
    rx: 1.25,
    ry: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 21.46,
    y: 40.69,
    width: 56.83,
    height: 2.5,
    rx: 1.25,
    ry: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 21.46,
    y: 46.48,
    width: 18.76,
    height: 2.5,
    rx: 1.25,
    ry: 1.25
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProwordCount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pro.wordCount.f05af884cb8db7231e0faac1c4caa8be.svg";